import { inject} from '@angular/core';
import { ResolveFn } from '@angular/router';
import { SharedConstants } from '@shared/constants';
import { EventService } from '@common/event.service';

export const backButtonResolver: ResolveFn<boolean> = (route, state) => {
    const eventService = inject(EventService);
    eventService.emitEvent(SharedConstants.UPDATE_BACK_BUTTON_EVENT, { showBack: false });
    return true;
};
